/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Progress_BodyInputs */

const en_portal_view_progress_body = /** @type {(inputs: Portal_View_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifts, weight, measurements and body photos on one chart. You can see yourself moving forward.`)
};

const pl_portal_view_progress_body = /** @type {(inputs: Portal_View_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciężary, waga, obwody i zdjęcia sylwetki na jednym wykresie. Widać, że idziesz do przodu.`)
};

/**
* | output |
* | --- |
* | "Lifts, weight, measurements and body photos on one chart. You can see yourself moving forward." |
*
* @param {Portal_View_Progress_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_progress_body = /** @type {((inputs?: Portal_View_Progress_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Progress_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_progress_body(inputs)
	return en_portal_view_progress_body(inputs)
});